export class CompetitorCount {
  total?: number;
  readyForPayment?: number;
  withStartNumber?: number;
  paidOrConfirmedCount?: number;
  finished?: number;
  started?: number;
  disqualified?: number;
  didNotFinished?: number;
  timeLimitExceeded?: number
  registeredCountriesCount?: number;
  finishedCountriesCount?: number;
  didNotStarted?: number;
}
